
<div class="modal fade" id="sharingModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
 class="modal full-modal fade">
	<div class="modal-dialog" role="document" style="max-width: 100%;">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">{{bs.getResource('rbkey_StngLBL')}}</h5>
				<button type="button" class="close" (click)="closePanel()" aria-label="Close"style="margin-right: 0%;margin-top: 0%;">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" style="background: #3d4758">
				<div class="leaderboard-drop-inner setting-panel-inner" style="background: white; border-radius: 5px; height: 100%;">
					<app-settings></app-settings>
					<div class="row">
						<div style="width:96%; margin-left:2%;">
							<a class="share-btn" style="margin-left: 10px; margin-top:10px;" href="javascript:void(0);" (click)="saveList()">{{bs.getResource('rbkey_UsrSvChngsBTN')}}</a>
							<a class="share-btn" style="margin-top:10px;" href="javascript:void(0);" (click)="showHideList()">{{bs.getResource('rbkey_HdUsrsLBL')}}</a>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>